import React from 'react'

function Material() {
  return <div />
}

export default Material
